'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _reduxForm = require('redux-form');
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _ramda = require('ramda');
var _OMButtonWithPreloader = require('../../OMComponents/OMButtonWithPreloader/OMButtonWithPreloader');var _OMButtonWithPreloader2 = _interopRequireDefault(_OMButtonWithPreloader);
var _ContactPersonField = require('../ContactPersonField/ContactPersonField');var _ContactPersonField2 = _interopRequireDefault(_ContactPersonField);
var _validate = require('./validate');var _validate2 = _interopRequireDefault(_validate);
var _Form = require('../Form/Form.scss');var styles = _interopRequireWildcard(_Form);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

UpdatePropertyActivityContactsVirtualNumbersForm = function (_React$Component) {_inherits(UpdatePropertyActivityContactsVirtualNumbersForm, _React$Component);function UpdatePropertyActivityContactsVirtualNumbersForm() {var _temp, _this, _ret;_classCallCheck(this, UpdatePropertyActivityContactsVirtualNumbersForm);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.
    state = {
      isShowSecondaryContact: false }, _this.


    toggleSecondaryContact = function () {
      if (_this.state.isShowSecondaryContact) {
        _this.props.change('secondary', null);
        _this.props.unregisterFormField('secondary');
      }
      _this.setState(function (prev) {return { isShowSecondaryContact: !prev.isShowSecondaryContact };});
    }, _this.

    handleSubmit = function (evt) {
      _this.props.handleSubmit(_this.props.onFormSubmit)(evt);
      return true;
    }, _temp), _possibleConstructorReturn(_this, _ret);}UpdatePropertyActivityContactsVirtualNumbersForm.prototype.

  render = function render() {var _cx, _cx2;var
    isShowSecondaryContact = this.state.isShowSecondaryContact;var _props =
    this.props,isRtl = _props.isRtl,isLoading = _props.isLoading,translate = _props.translate,virtualNumbers = _props.virtualNumbers;

    var isOnlyOneVirtualNumber = virtualNumbers.length === 1;

    return (
      _react2.default.createElement('form', {
          className: styles.form,
          onSubmit: this.handleSubmit,
          noValidate: 'noValidate' },

        _react2.default.createElement(_ContactPersonField2.default, {
          translate: translate,
          isRtl: isRtl,
          virtualNumbers: virtualNumbers,
          isRequired: true,
          name: 'primary' }),

        isShowSecondaryContact &&
        _react2.default.createElement(_ContactPersonField2.default, {
          translate: translate,
          isRtl: isRtl,
          virtualNumbers: virtualNumbers,
          name: 'secondary' }),


        _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.actions, (_cx = {}, _cx[styles.centered] = isOnlyOneVirtualNumber, _cx)) },
          isShowSecondaryContact && !isOnlyOneVirtualNumber &&
          _react2.default.createElement('button', {
              type: 'button',
              onClick: this.toggleSecondaryContact,
              className: (0, _classnames2.default)(styles.btn, styles.outlinedBtn, styles.removeBtn) },

            translate(
            'managePage',
            'propertyToggle',
            'missingContactsModal',
            'removeSecondaryContact')),



          !isShowSecondaryContact && !isOnlyOneVirtualNumber &&
          _react2.default.createElement('button', {
              type: 'button',
              onClick: this.toggleSecondaryContact,
              className: (0, _classnames2.default)(styles.btn, styles.outlinedBtn, styles.addBtn) },

            translate(
            'managePage',
            'propertyToggle',
            'missingContactsModal',
            'addSecondaryContact')),



          _react2.default.createElement(_OMButtonWithPreloader2.default, {
            type: 'submit',
            showPreloader: isLoading,
            additionalClassName: (0, _classnames2.default)(styles.btn, styles.submitBtn, (_cx2 = {}, _cx2[styles.large] = isOnlyOneVirtualNumber, _cx2)),
            innerText: translate(
            'managePage',
            'propertyToggle',
            'missingContactsModal',
            'activate') }))));





  };return UpdatePropertyActivityContactsVirtualNumbersForm;}(_react2.default.Component);


UpdatePropertyActivityContactsVirtualNumbersForm.propTypes = {
  translate: _propTypes2.default.func,
  isRtl: _propTypes2.default.bool,
  virtualNumbers: _propTypes2.default.array,
  handleSubmit: _propTypes2.default.func,
  unregisterFormField: _propTypes2.default.func,
  untouch: _propTypes2.default.func,
  change: _propTypes2.default.func,
  onFormSubmit: _propTypes2.default.func,
  isLoading: _propTypes2.default.bool };


var mapStateToProps = function mapStateToProps(_ref) {var userAuthentication = _ref.userAuthentication;
  var virtualNumbers = (0, _get2.default)(userAuthentication, 'data.virtual_numbers') || [];
  return {
    virtualNumbers: virtualNumbers };

};

var unregisterFormField = function unregisterFormField(name) {return (0, _reduxForm.unregisterField)('update-property-activity-contacts-virtual-numbers-form', name);};exports.default =

(0, _ramda.compose)(
(0, _reactRedux.connect)(mapStateToProps, { unregisterFormField: unregisterFormField }),
(0, _reduxForm.reduxForm)({
  form: 'update-property-activity-contacts-virtual-numbers-form',
  validate: _validate2.default }))(
UpdatePropertyActivityContactsVirtualNumbersForm);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/UpdatePropertyActivityModal/VirtualNumbersForm/VirtualNumbersForm.js
// module id = 2924
// module chunks = 0